const helpPageBaseLayer = {
  page: '/pyme/centro-ayuda',
  page_title: 'Pyme – Centro de ayuda',
};

const helpPageEvents = {
  home: {
    ...helpPageBaseLayer,
    action_type: 'Pageview',
    action: 'PYME – Centro de ayuda',
  },
};

export { helpPageBaseLayer, helpPageEvents };
